import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounce } from 'lodash';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { LineService } from 'src/app/api/catalog/line.service';
import { CategoryService } from 'src/app/api/catalog/category.service';
declare var $: any;

@Component({
  selector: 'app-line-form',
  templateUrl: './line-form.component.html',
  styleUrls: ['./line-form.component.css']
})
export class LineFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  @ViewChild('searchInputCategory') searchInputCategory: any;
  keyword = 'description';
  categories: any = [];
  isTypedSearch = false;
  classSearch: string = 'search-small';
  initialCategory: any = null;
  previewCategory: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private lineService: LineService,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      category_id: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.getCategories();
    if (this.isEdit) {
      this.editData();
    }
    this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getCategories() {
    this.categoryService.all().subscribe({
      next: (data: any) => {
        this.categories = data.results;
      }
    });
  }

  editData() {
    this.lineService.get(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        this.item.patchValue({
          description: result.description,
          category_id: result.category_id
        });

        if (!_.isNull(result.category_id)) {
          this.previewCategory = true;
          setTimeout(() => {
            this.initialCategory = result.category;
          }, 50);          
        }
      }
    });
  }

 

  selectSearchCategory(item_: any) {
    if (this.previewCategory) {
      this.previewCategory = false;
    } else {
      this.item.patchValue({
        category_id: item_.id
      });
    }

    (<any>$('.input-container input')).attr('disabled', true);
  }

  clearedSearchCategory(): void {
    this.item.patchValue({
      category_id: null
    });
    (<any>$('.input-container input')).attr('disabled', false);
    this.searchInputCategory.focus();
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.lineService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.lineService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/catalogo/lineas/lista']);
  }
}
